import { render } from "./ItemsDaily.vue?vue&type=template&id=4f194f8c&scoped=true"
import script from "./ItemsDaily.vue?vue&type=script&lang=js"
export * from "./ItemsDaily.vue?vue&type=script&lang=js"

import "./ItemsDaily.vue?vue&type=style&index=0&id=4f194f8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f194f8c"]])

export default __exports__